/**
 * Locals
*/

const ordinals = ['th', 'st', 'nd', 'rd'];
const htmlregex = /[&<>"']/g;
const htmlmap: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#039;',
};

/**
 * Public Functions
*/

export function StrCount(
  haystack: string,
  needle: string | Array<string>): number
{
  if (!needle.length) {
    return 0;
  } else if (typeof needle === 'string') {
    needle = [needle];
  }

  let count = 0;

  for (const item of needle) {
    let index = haystack.indexOf(item);

    while (index !== -1) {
      count++;
      index = haystack.indexOf(item, index + 1);
    }
  }

  return count;
}

/**
 * @return {string}
 */
function _escape(
  char: string): string
{
  return htmlmap[char];
}

/**
 * @return {string}
 */
export function EscapeHTML(
  unescaped: string): string
{
  return unescaped.replace(htmlregex, _escape);
}

/**
 * @return {number}
 */
export function RandomInt(
  min: number,
  max: number): number
{
  if (min === max) {
    return min;
  }

  const range = max - min + 1;
  const bytes_needed = Math.ceil(Math.log2(range) / 8);
  const cutoff = Math.floor((256 ** bytes_needed) / range) * range;
  const bytes = new Uint8Array(bytes_needed);

  let value;

  do {
    crypto.getRandomValues(bytes);
    value = bytes.reduce((acc, x, n) => acc + x * 256 ** n, 0);
  } while (value >= cutoff);

  return min + value % range;
}

/**
 * @return {Ty}
 */
export function RandomFrom<Ty>(
  elements: Array<Ty>): Ty
{
  const max = elements?.length;

  if (!max) {
    return null;
  } else if (max === 1) {
    return elements[0];
  }

  return elements[RandomInt(0, max - 1)];
}

/**
 * @param {number} amount
 *
 * @return {string}
 */
export function NumberOrdinal(
  amount: number): string
{
  const v = amount % 100;

  return ordinals[(v - 20) % 10] || ordinals[v] || ordinals[0];
}

/**
 * @param {Date} first
 * @param {Date} second
 *
 * @return {number}
 */
export function DateDiffSeconds(
  first: Date,
  second: Date): number
{
  return Math.abs((first ? first.getTime() : 0) - (second ? second.getTime() : 0));
}

export function StrUcFirst(
  word: string): string
{
  return word && (word[0].toUpperCase() + word.slice(1));
}
